import { useMutation } from "urql";

import { UpdateCollateralStatusDocument } from "../../../graphql/generated.ts";

export const useUpdateCollateralStatus = () =>
  useMutation(UpdateCollateralStatusDocument);
